module.exports = __webpack_public_path__ + "static/2-c361f0e7dc1784baf5024a378ecb5619.jpg";